import { useParams } from 'react-router-dom';

export const useIsAuctionGroup = () => {
  const { id } = useParams<{ id: string }>();
  return !!id && id.split(',').length > 1;
};
